<template>
    <footer id="wrapper" class="kl-footer">
    
              
       

  <div class="kl-footer__wrapper content-wrapper">
    
    <div class="kl-footer__content" style="padding: 10px 0;">

      <div class="kl-footer__info">
      
        <a href="#">
    
            <img src="https://mentormentee.com/hubfs/Mentor_Mentee_May2025/Images/Large_Logo_White.png" alt="Mentor Mentee" width="100%" style="max-width: 134px; max-height: 51px" loading="">
         </a>
  

        <div class="kl-footer__address"><p>Build People. Build Profits.</p>

        <p style="margin-bottom: 0px;"><br>(816) 375-7430<br>N Kansas City, MO</p>
        <ul>
        <li><a href="https://apps.apple.com/in/app/mentormentee/id1541844880" target="_blank" rel="noopener">
            <img :src="mmImageSiteUrl +'hs-fs/hubfs/Mentor_Mentee_May2025/Images/app-store-icon-159x47.png?width=90&height=26&name=app-store-icon-159x47.png'"  alt="apple store">
        </a></li>
        <li><a href="https://play.google.com/store/apps/details?id=com.poweredbyu.mentoring" target="_blank" rel="noopener">
            <img :src="mmImageSiteUrl +'hs-fs/hubfs/Mentor_Mentee_May2025/Images/google-play-badge-159x47.png?width=90&height=26&name=google-play-badge-159x47.png'" alt="google play store">
        </a></li>
        </ul>
    </div>

        <ul class="kl-footer__social" style="margin-left: 0px;">          
            <li><a href="https://www.linkedin.com/company/mentormentee" target="_blank" style="color: #002F42; font-size: 32px; font-weight: bold;"><i class="fa fa-linkedin-square"></i></a></li>  
             <li style="padding-left: 10px;""><a href="https://www.facebook.com/mentormenteeapp" target="_blank" style="color: #002F42; font-size: 32px; font-weight: bold;"><i class="fa fa-facebook-square"></i></a></li>                
        </ul>
    </div>

      <div class="kl-footer__menu">        
          <div class="kl-footer__group">              
            <ul>              
                <li>
                  <a href="https://app.mentormentee.com/mmlogin">Login</a>
                </li>
              
                <li>
                  <a :href="mmSiteUrl + 'technical-mentoring-news?hsLang=en'">News</a>
                </li>
              
                <li>
                  <a :href="mmSiteUrl + 'contact-us?hsLang=en'" >Contact Us</a>
                </li>
              
            </ul>
          </div>
        
          <div class="kl-footer__group">
              
            <ul>
              
                <li>
                  <a :href="mmSiteUrl + 'product?hsLang=en'" >Product</a>
                </li>
              
                <li>
                  <a :href="mmSiteUrl + 'faq?hsLang=en'" >FAQ’s</a>
                </li>
              
            </ul>
          </div>
        
      </div>

    </div>
    

    
    <div class="kl-footer__legal">
      <p style="text-align: center;"><span>© Mentor Mentee 2025</span> | <a :href="mmSiteUrl + 'privacy-policy?hsLang=en'" >Privacy Policy</a> | <a :href="mmSiteUrl + '/terms-of-use?hsLang=en'">Terms Of Service</a></p>
    </div>
    

  </div>

  
  <div class="kl-footer__byline-wrapper">
    <div class="content-wrapper">
      <div class="kl-footer__byline">
        <span>
          <a href="https://www.kalungi.com/atlas-hubspot-theme-for-b2b-saas-software">
            Powered by Atlas - a B2B SaaS HubSpot theme
            <!-- Made by: https://github.com/pipriles -->
          </a>
        </span>
      </div>
    </div>
  </div>

 </footer>
</template>

<style scoped>
/* Footer Styles */

.kl-footer {
  background-color: rgba(0, 172, 238, 1.0);
}
.kl-footer .content-wrapper {
    margin: 0 auto;
    max-width: 1170px;
}
.content-wrapper {
  margin: 0 auto;
  padding: 0 20px;
  max-width: 1170px;
}

@media screen and (min-width: 1380px) {
  .content-wrapper {
    padding: 0;
  }
}
.kl-footer h1, .kl-footer h2, .kl-footer h3, .kl-footer h4, .kl-footer h5, .kl-footer h6, .kl-footer p, .kl-footer a, .kl-footer div, .kl-footer span {
  color: rgba(255, 255, 255, 1.0);
}

.kl-footer__wrapper {
  width: 100%;
  padding-top: 32px;
  padding-bottom: 32px;
}

.kl-footer__legal {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 0.875rem;
  margin: -0.625rem -1.25rem;
}

.kl-footer__legal > span {
  margin: 0.625rem 1.25rem;
  color: rgba(255, 255, 255, 1.0);
}

.kl-footer__legal a {
  color: rgba(255, 255, 255, 1.0);
}

.kl-footer__legal a:hover, .kl-footer__legal a:focus, .kl-footer__legal a:active {
  color: rgba(255, 255, 255, 1.0);
  text-decoration: none;
}

.kl-footer__byline {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 0.85rem;
  padding: 0px 0px 10px 0px;
}



.kl-footer__content {
  display: flex;
  justify-content: space-between;
  padding: 120px 0;
}
.kl-footer__info {
  flex-basis: 250px;
}
.kl-footer__wrapper {
  width: 100%;
  padding-top: 32px;
  padding-bottom: 32px;
}
.kl-footer__info img {
  display: block;
  width: auto;
  height: auto;
  margin: 0;
}

.kl-footer__info p {
  font-size: 0.875em;
}

.kl-footer__social {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0 -16px;
}

.kl-footer__social span {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  margin: 8px 16px;
}

.kl-footer__social svg {
  display: block;
  width: 25px;
  height: 25px;
  fill: rgba(255, 255, 255, 1.0);
  transition: all .25s ease-in-out;
}

.kl-footer__social a:hover svg {
  fill: #00ACEE;
}

.kl-footer__menu {
  display: flex;
  flex-wrap: wrap;
  margin: -16px 0;
}


@media screen and (max-width: 680px) {
  .kl-footer__menu {
    margin: 16px -16px 0;
  }
}

.kl-footer__menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.kl-footer__menu h3 {
  font-size: 1.125rem;
  font-weight: bold;
  margin: 0 0 2rem;
  color: rgba(255, 255, 255, 1.0);
}

.kl-footer__menu a {
  display: block;
  font-size: 0.875em;
  font-weight: 500;
  line-height: 17px;
  color: rgba(255, 255, 255, 1.0);
  margin: 0 0 1.375em;
}

.kl-footer__menu a:hover, .kl-footer__menu a:focus, .kl-footer__menu a:active {
  color: #00ACEE;
  text-decoration: none;
}

.kl-footer__group {
  margin: 16px 42px;
}

@media screen and (max-width: 680px) {
  .kl-footer__group {
    margin: 16px;
  }
}
.kl-footer__address {
  margin: 32px 0 16px;
}

.kl-footer__info ul {
    display: flex;
    list-style: none;
    margin-bottom: 10px;
    margin-left: -5px;
    margin-top: 10px;
    padding: 0
}
form .hs-richtext p {
    color: #99999b;
    font-size: 17px
}

.kl-footer__info p {
    font-size: 15px;
    margin: 0 0 10px
}
.kl-footer__info ul {
    display: flex;
    list-style: none;
    margin-bottom: 10px;
    margin-left: -5px;
    margin-top: 10px;
    padding: 0
}

.kl-footer__menu a {
    font-size: 16px;
    line-height: 1.42857142857;
    margin-bottom: 10px
}
.kl-footer__menu a:hover {
    color: #FFF !important;
    text-decoration: underline;
}

.kl-footer__legal {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 0.975rem !important;
  margin: -0.625rem -1.25rem;
}
.btm-pane-wrap {
    padding: 20px;
}

.btm-pane-wrap .page-center {
    margin: 0 auto;
    max-width: 1170px;
}
.btm-pane-wrap p {
    font-family: proxima-nova,Arial,verdana;
    font-size: 16px;
    margin-bottom: 10px
}
@media screen and (max-width: 680px) {
    .kl-footer__content {
        display: block;
    }
}
</style>

<script>

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VueScriptComponent from 'vue-script-component';

export default {
    props: ['mmSiteUrl'],
    data() {
        return {
          mentoringUrl: process.env.VUE_SITE_URL,
          env: process.env.NODE_ENV,
          mmImageSiteUrl: process.env.MM_IMAGE_SITE_URL,
        }
    },
    components: {     
        VueScriptComponent,       
    },
}
</script>




// WEBPACK FOOTER //
// src/components/mm_footer.vue